import { mergeObjectTypes } from '../cacheHelpers';

const InFull = {
  merge: mergeObjectTypes
};

export default InFull;
